import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "user-select" }
const _hoisted_2 = {
  key: 0,
  class: "user-select__avatar-list"
}
const _hoisted_3 = { class: "is-subheader" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_details_development = _resolveComponent("details-development")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_details_development, { info: _ctx.infoDetails }, null, 8, ["info"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewControlAvatar && _ctx.viewControlAvatar(...args)))
      }, _cache[9] || (_cache[9] = [
        _createElementVNode("i", { class: "icon-nav-user" }, null, -1),
        _createElementVNode("i", { class: "icon-nav-bullet_down" }, null, -1)
      ])),
      (_ctx.showMenuAvatar)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            _cache[13] || (_cache[13] = _createElementVNode("li", { class: "is-header" }, [
              _createTextVNode(" MINHA CONTA "),
              _createElementVNode("i", { class: "icon-nav-bullet_up" })
            ], -1)),
            _createElementVNode("li", _hoisted_3, _toDisplayString(_ctx.store.getters["user/user"].email), 1),
            (_ctx.checkEnvironment)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toogleTheme && _ctx.toogleTheme(...args))),
                  innerHTML: _ctx.toggleLabel
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.checkEnvironment)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 1,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toGoLink('icons')))
                }, "Ícones"))
              : _createCommentVNode("", true),
            (_ctx.checkEnvironment)
              ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { for: "switch1" }, "Detalhes", -1)),
                  _createVNode(_component_InputSwitch, {
                    modelValue: _ctx.showDetailsDevelopment,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showDetailsDevelopment) = $event)),
                    inputId: "switch1"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.checkEnvironment)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 3,
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toGoStorybook && _ctx.toGoStorybook(...args)))
                }, "Storybook"))
              : _createCommentVNode("", true),
            (_ctx.featureFlag)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 4,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toGoLink('historical-consumption')))
                }, _cache[11] || (_cache[11] = [
                  _createElementVNode("i", { class: "icon-nav-report" }, null, -1),
                  _createTextVNode(" Consumo de pacote ")
                ])))
              : _createCommentVNode("", true),
            (_ctx.checkEnvironment)
              ? (_openBlock(), _createElementBlock("li", {
                  key: 5,
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
                }, "Novo Code"))
              : _createCommentVNode("", true),
            _createElementVNode("li", {
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
            }, _cache[12] || (_cache[12] = [
              _createElementVNode("i", { class: "icon-nav-arrow_right" }, null, -1),
              _createTextVNode(" Sair ")
            ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showMenuAvatar)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "user-select__wrapper",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.hideViewAvatar && _ctx.hideViewAvatar(...args)))
        }))
      : _createCommentVNode("", true)
  ], 64))
}